import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { Brand } from '../models/brand.model'

export const useBrandStore = defineStore('brand', () => {
  const brand = ref<Brand>()

  const apply = (clientBrand?: Brand): void => {
    const root = document.querySelector<HTMLElement>(':root')
    if (root) {
      root.style.setProperty('--color-brand', clientBrand ? clientBrand.primaryColor : '#53ab47')
      root.style.setProperty(
        '--color-brand-contrast',
        clientBrand ? clientBrand.primaryTextColor : '#ffffff',
      )
      root.style.setProperty(
        '--color-surface',
        clientBrand ? clientBrand.secondaryTextColor : '#ffffff',
      )
      root.style.setProperty(
        '--color-surface-inverse',
        clientBrand ? clientBrand.secondaryColor : '#242426',
      )
      root.style.setProperty(
        '--color-accent-light',
        clientBrand ? clientBrand.footerTextColor : '#ffffff',
      )
      root.style.setProperty(
        '--color-accent-dark',
        clientBrand ? clientBrand.footerColor : '#242426',
      )
      brand.value = clientBrand
    }
  }

  return { brand, apply }
})
